import { useCallback, useState } from "react";
import { Form, Input, Tag } from "antd";
import PhoneInput from "../../../components/shared/PhoneInput";
import Modal from "../../../components/generic/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTenants,
  selectUser,
} from "../../../store/user/selectors";
import { saveProfile } from "../../../store/user/thunks";
import { ProfileOutlined } from "@ant-design/icons";

const UpdateProfile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const tenants = useSelector(selectSelectedTenants);

  const handleOk = useCallback(
    async (values) => {
      try {
        setSubmitting(true);
        await dispatch(
          saveProfile({ ...values, middle_name: values?.middle_name || "" }),
        );
      } catch (error) {
        console.log(
          "🚀 ~ UpdateProfile.jsx:18 ~ UpdateProfile ~ error:",
          error,
        );
      } finally {
        setSubmitting(false);
      }
    },
    [form],
  );

  return (
    <>
      <div onClick={() => setIsModalOpen(true)}>
        <span
          role="img"
          aria-label="profile"
          className="anticon anticon-profile ant-dropdown-menu-item-icon cursor-pointer"
        >
          <ProfileOutlined />
        </span>
        <span className="ant-dropdown-menu-title-content cursor-pointer">
          <span className="ant-dropdown-menu-title-content">Profile</span>
        </span>
      </div>
      {isModalOpen && (
        <Modal
          title="Profile"
          open
          onCancel={() => setIsModalOpen(false)}
          width={500}
          styles={{
            body: {
              maxHeight: "60dvh",
              overflowY: "auto",
            },
          }}
          isProcessing={submitting}
          okButtonProps={{
            loading: submitting,
            onClick: () => form.submit(),
            disabled: submitting,
          }}
          okText={"Save Changes"}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleOk}
            initialValues={user || {}}
            disabled={submitting}
          >
            <Form.Item label="Email">
              <Input value={user?.email} disabled />
            </Form.Item>

            <Form.Item
              label="First Name"
              name="first_name"
              rules={[
                { required: true, message: "Please input your first name!" },
              ]}
            >
              <Input placeholder="Enter first name" />
            </Form.Item>

            <Form.Item label="Middle Name" name="middle_name">
              <Input placeholder="Enter middle name" defaultValue={""} />
            </Form.Item>

            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[
                { required: true, message: "Please input your last name!" },
              ]}
            >
              <Input placeholder="Enter last name" />
            </Form.Item>

            <PhoneInput />

            <Form.Item label="Tenants">
              <div className="flex-col " style={{ gap: "10px" }}>
                {tenants?.map((tenant, i) => (
                  <div
                    className="flex justify-space-between align-center"
                    key={tenant.id}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #f0f0f0",
                      borderRadius: "4px",
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>{tenant.name}</span>
                    <Tag color={i % 2 === 0 ? "blue" : "green"}>
                      {tenant.role}
                    </Tag>
                  </div>
                ))}
              </div>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default UpdateProfile;
